import { render, staticRenderFns } from "./EditAffiliatePage.vue?vue&type=template&id=9d7f854c&scoped=true&"
import script from "./EditAffiliatePage.vue?vue&type=script&lang=js&"
export * from "./EditAffiliatePage.vue?vue&type=script&lang=js&"
import style0 from "./EditAffiliatePage.vue?vue&type=style&index=0&id=9d7f854c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d7f854c",
  null
  
)

export default component.exports